export default "__VITE_ASSET__CEj2g8Tl__"